import React from 'react';
import { defineMessages } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { TrendsSectionCard } from '../components/TrendsSectionCard/TrendsSectionCard';

// The same two headings the Insights panel already uses, so one screen does
// not call it "Trending up" while another calls it something else.
const messages = defineMessages({
  trending: { id: 'app.sml.insights.trendingUp.title', defaultMessage: 'Trending up' },
  unusual: { id: 'app.sml.insights.anomalies.title', defaultMessage: 'Unusual activity' },
});

/** Row counts come from the design's Home panes: TrendingCard 4, UnusualCard 3. */
const TRENDING_ROWS = 4;
const UNUSUAL_ROWS = 3;

/**
 * The design's Home TrendingCard + UnusualCard. Both read the tracks side, the
 * one a follower acts on first; the Trends screen carries the artist lists too.
 */
const WatchlistTrendsRowComponent: React.FC = () => (
  <Row className="mb-4 g-3">
    <Col xs={12} xl={6}>
      <TrendsSectionCard
        title={messages.trending}
        category="trendingUp"
        entityType="track"
        paginationParamName="homeTrendingPage"
        limit={TRENDING_ROWS}
      />
    </Col>
    <Col xs={12} xl={6}>
      <TrendsSectionCard
        title={messages.unusual}
        category="anomalies"
        entityType="track"
        paginationParamName="homeUnusualPage"
        limit={UNUSUAL_ROWS}
      />
    </Col>
  </Row>
);

export const WatchlistTrendsRow = TypedMemo(WatchlistTrendsRowComponent);
